/**
 * "Viewed 2h ago" — matches the copy in the locked design.
 *
 * Takes an explicit `now` so tests are deterministic; the default is only
 * for callers that genuinely want wall-clock.
 */
export function relativeTime(iso: string, now: Date = new Date()): string {
  // floor, not round: elapsed time should never claim more time has passed than
  // actually has. Math.round turns 30 seconds into "1m ago" and 90 seconds into
  // "2m ago", both of which overstate the age of the event.
  const seconds = Math.max(0, Math.floor((now.getTime() - Date.parse(iso)) / 1000))
  const minutes = Math.floor(seconds / 60)
  if (minutes < 1) return 'just now'
  if (minutes < 60) return `${minutes}m ago`

  const hours = Math.floor(minutes / 60)
  if (hours < 24) return `${hours}h ago`

  const days = Math.floor(hours / 24)
  if (days === 1) return 'yesterday'
  if (days < 7) return `${days} days ago`

  const weeks = Math.floor(days / 7)
  if (weeks < 5) return weeks === 1 ? 'last week' : `${weeks} weeks ago`

  const months = Math.floor(days / 30)
  return months === 1 ? 'last month' : `${months} months ago`
}

/**
 * "May 8, 2025" — the date format the locked design uses.
 *
 * Parsed as UTC deliberately: a bare "2025-05-08" parsed as local time can
 * render as May 7 for anyone west of UTC.
 */
export function formatDate(isoDate: string): string {
  const d = new Date(`${isoDate}T00:00:00Z`)
  return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric', timeZone: 'UTC' })
}
